var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDriverIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 31,
    fill: "#002CB1",
    stroke: "#D4F4FA",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 45.2492L45.5792 46.615L44.9833 44.0392L47 42.3158L44.3508 42.0867L43.3333 39.6667L42.2975 42.0867L39.6667 42.3158L41.665 44.0392L41.0417 46.615L43.3333 45.2492ZM37.9067 44.25H26.8333C25.8342 44.2133 25.0367 43.4158 25 42.4167V29.5833C25.0367 28.5842 25.8342 27.7867 26.8333 27.75H45.1667C46.1658 27.7867 46.9633 28.5842 47 29.5833V39.2358C46.4683 38.75 45.8542 38.3925 45.1667 38.145V29.5833H26.8333V42.4167H37.9067C37.8608 42.7192 37.8333 43.0217 37.8333 43.3333C37.8333 43.645 37.8608 43.9567 37.9067 44.25ZM37.8333 40.5833H28.6667V39.4375C28.6667 37.9158 31.7283 37.1458 33.25 37.1458C34.7717 37.1458 37.8333 37.9158 37.8333 39.4375V40.5833ZM37.8333 35.0833H41.5V36H37.8333V35.0833ZM33.25 31.4167C31.9942 31.4167 30.9583 32.4525 30.9583 33.7083C30.9583 34.9642 31.9942 36 33.25 36C34.5058 36 35.5417 34.9642 35.5417 33.7083C35.5417 32.4525 34.5058 31.4167 33.25 31.4167ZM37.8333 33.25H43.3333V34.1667H37.8333V33.25ZM37.8333 31.4167H43.3333V32.3333H37.8333V31.4167Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDriverIcon);
export default __webpack_public_path__ + "static/media/AddDriverIcon.6290cdbf8bb2dfa0a2ad4d5fdcf3a3d8.svg";
export { ForwardRef as ReactComponent };